import React from 'react'

export default function InfoCardsVendor({ data }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">


            <div id="vendor-stats-1" className="bg-white rounded-lg shadow p-6">
                <div className="flex items-center mb-4">
                    <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                        <i className="fa-solid fa-store text-blue-600"></i>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800">Total Vendors</h3>
                    </div>
                </div>
                <div className="flex items-end justify-between">
                    <span className="text-3xl font-bold text-gray-800">{data?.totalVendors}</span>
                    <span
                        className={`text-sm flex items-center ${data?.vendorGrowth >= 0 ? "text-green-600" : "text-red-600"
                            }`}
                    >
                        <i
                            className={`fa-solid ${data?.vendorGrowth >= 0 ? "fa-arrow-up" : "fa-arrow-down"
                                } mr-1`}
                        />

                        {Math.abs(data?.vendorGrowth)}%
                        <span className="text-gray-500 ml-1">vs last month</span>
                    </span>
                </div>
            </div>


            <div id="vendor-stats-2" className="bg-white rounded-lg shadow p-6">
                <div className="flex items-center mb-4">
                    <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3">
                        <i className="fa-solid fa-check-circle text-green-600"></i>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800">Active Partnerships</h3>
                    </div>
                </div>
                <div className="flex items-end justify-between">
                    <span className="text-3xl font-bold text-gray-800">{data?.activePartnerships}</span>
                    <span
                        className={`text-sm flex items-center ${data?.partnershipGrowth >= 0 ? "text-green-600" : "text-red-600"
                            }`}
                    >
                        <i
                            className={`fa-solid ${data?.partnershipGrowth >= 0 ? "fa-arrow-up" : "fa-arrow-down"
                                } mr-1`}
                        ></i>
                        {Math.abs(data?.partnershipGrowth)}%
                        <span className="text-gray-500 ml-1">vs last month</span>
                    </span>
                </div>
            </div>


            <div id="vendor-stats-3" className="bg-white rounded-lg shadow p-6">
                <div className="flex items-center mb-4">
                    <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3">
                        <i className="fa-solid fa-box text-purple-600"></i>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800">Pending Partnerships</h3>
                    </div>
                </div>
                <div className="flex items-end justify-between">
                    <span className="text-3xl font-bold text-gray-800">{data?.pendingPartnerships}</span>
                    <span
                        className={`text-sm flex items-center ${data?.partnershipPendingGrowth < 0 ? "text-green-600" : "text-red-600"
                            }`}
                    >
                        <i
                            className={`fa-solid ${data?.partnershipPendingGrowth >= 0 ? "fa-arrow-up" : "fa-arrow-down"
                                } mr-1`}
                        ></i>
                        {Math.abs(data?.partnershipPendingGrowth)}%
                        <span className="text-gray-500 ml-1">vs last month</span>
                    </span>
                </div>
            </div>
        </div>
    )
}
